


<div>
  <div class="content-container">
    <!-- <mat-icon id="close-icon" (click)="closeDialog()">close</mat-icon> -->
    <div class="row">
      <p class="text-info">Copy and open the link on new tab</p>
      <input type="email" value="{{data.link}}" readonly
      class="form-control" placeholder="Email"> 
    </div>  </div>
  <mat-dialog-actions align="end">
      <button mat-flat-button id="no-button"  class="btn btn-default waves-effect" [mat-dialog-close]="false">Close</button>
  </mat-dialog-actions>

</div>